import moment from "moment-timezone";

// The daily rollup's `date` grain is IST — every range here is computed
// against IST calendar days, not the browser/server's local timezone.
export const IST = "Asia/Calcutta";

export function istToday() {
  return moment.tz(IST).format("YYYY-MM-DD");
}

export function istYesterday() {
  return moment.tz(IST).subtract(1, "day").format("YYYY-MM-DD");
}

export const RANGE_PRESETS = [
  { key: "7d", label: "7d", days: 7 },
  { key: "30d", label: "30d", days: 30 },
  { key: "custom", label: "Custom" },
];

// Pure: takes IST 'YYYY-MM-DD' strings in, never reads the clock itself, so
// callers (and tests) fully control "today".
export function rangeForPreset(preset, customDate, today) {
  const match = RANGE_PRESETS.find((p) => p.key === preset) || RANGE_PRESETS[0];
  if (match.key === "custom") {
    const day = customDate || today;
    return { from: day, to: day };
  }
  const from = moment
    .tz(today, IST)
    .subtract(match.days - 1, "days")
    .format("YYYY-MM-DD");
  return { from, to: today };
}

export function rangeLabel(range) {
  if (!range) return "";
  return range.from === range.to ? range.from : `${range.from} → ${range.to}`;
}
